import { useState } from 'react';
import { copyText } from '@/lib/share';

interface Props {
  shareUrl: string;
  title: string;
  dateText: string;
}

type ShareCapableNavigator = Navigator & {
  share?: (data: { title?: string; text?: string; url?: string }) => Promise<void>;
};

export default function ShareBar({ shareUrl, title, dateText }: Props) {
  const [note, setNote] = useState('');
  const [copied, setCopied] = useState(false);

  const flash = (msg: string) => {
    setNote(msg);
    window.setTimeout(() => setNote((cur) => (cur === msg ? '' : cur)), 2800);
  };

  const message = `${title}${dateText ? `\n${dateText}` : ''}`;

  const handleKakao = async () => {
    if (!shareUrl) return;
    const nav = navigator as ShareCapableNavigator;
    if (typeof nav.share === 'function') {
      try {
        await nav.share({ title, text: message, url: shareUrl });
        return;
      } catch (err) {
        if (err instanceof DOMException && err.name === 'AbortError') return;
      }
    }
    const ok = await copyText(`${message}\n${shareUrl}`);
    flash(
      ok
        ? '초대 문구와 주소를 복사했어요. 카카오톡에 붙여넣어 전해 주세요.'
        : '복사하지 못했어요. 주소를 길게 눌러 복사해 주세요.',
    );
  };

  const handleCopy = async () => {
    if (!shareUrl) return;
    const ok = await copyText(shareUrl);
    setCopied(ok);
    if (ok) window.setTimeout(() => setCopied(false), 1800);
    flash(ok ? '주소를 복사했어요.' : '복사하지 못했어요. 주소를 길게 눌러 복사해 주세요.');
  };

  return (
    <div className="inv-sharebar">
      {note ? (
        <p className="inv-share-note" role="status">
          {note}
        </p>
      ) : null}
      <div className="inv-share-inner">
        <button type="button" className="inv-share-btn kakao" onClick={() => void handleKakao()}>
          <i className="ri-kakao-talk-fill" aria-hidden="true" />
          카카오톡으로 전하기
        </button>
        <button type="button" className="inv-share-btn copy" onClick={() => void handleCopy()}>
          <i className={copied ? 'ri-check-line' : 'ri-link'} aria-hidden="true" />
          {copied ? '복사됨' : '주소 복사하기'}
        </button>
      </div>
    </div>
  );
}